<section>
  <div class="container mt-3">
    <form>
      <button class="btn btn-success" (click)="modificarVehiculo(0)">Nuevo Vehiculo</button>
      <table class="table mt-3 table-hover table-sm table-responsive table-bordered border-dark text-center">
        <thead class="table-dark">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Marca</th>
            <th scope="col">Modelo</th>
            <th scope="col">Año</th>
            <th scope="col">Patente</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody class="table-light">
          <tr *ngFor="let m of vehiculos">
            <th>{{m.id}}</th>
            <th>{{m.marca}}</th>
            <th>{{m.modelo}}</th>
            <th>{{m.ano}}</th>
            <th>{{m.patente}}</th>
            <th>
              <button type="button" class="btn btn-primary btn-sm" (click)="modificarVehiculo(m.id)">Modificar</button>
            </th>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</section>